<template>
	<div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {

		data() {
			return {


			}

		},
		created() {},

		mounted() {

		},
		methods: {
			download(downurl,item) {
				// let formData = new FormData();
				// for (var key in parmobj) {
				// 	formData.append(key, parmobj[key]);
				// }
				 const loading = this.$loading({
				          lock: true,
				          text: 'Loading',
				          spinner: 'el-icon-loading',
				          background: 'rgba(0, 0, 0, 0.7)'
				        });
				axios({
					method: "post",
					url:downurl,
					headers: {
						"token": localStorage.getItem('token')
					},
					 data: item,
					responseType: "blob"
				}).then((res) => {
					loading.close()
					var fileName2=""
					var blob=""
					if(item.fileType.toLowerCase()=="pdf"){
						 blob = new Blob([res.data],{type: 'application/pdf'});
					}
					if(item.fileType.toLowerCase()=="jpg"){
						 blob = new Blob([res.data],{type: 'image/jpeg'});
					}
					 if(item.fileType.toLowerCase()=="png"){
					 	 blob = new Blob([res.data],{type: 'image/png'});
					 }
					 if(item.fileType.toLowerCase()=="xls"){
					 	 blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
					 }
					 if(item.fileType.toLowerCase()=="xlsx"){
					 	 blob = new Blob([res.data],{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
					 }
					 if(item.fileType.toLowerCase()=="zip"){
					 	 blob = new Blob([res.data],{type: 'application/x-zip-compressed'});
					 }
					if(res.headers['content-disposition']){
						  fileName2=res.headers['content-disposition'].split('fileName=')[1]
						   blob = new Blob([res.data],{type: 'multipart/form-data'});
					}else{
						 fileName2 = item.fileName;
					}

					   if (window.navigator && window.navigator.msSaveOrOpenBlob) { // 兼容IE
					           window.navigator.msSaveOrOpenBlob(blob,fileName2); // 可以自定义文件名称及后缀
					      } else {
					        const link = document.createElement('a');
					        link.style.display = 'none';
					        link.href = URL.createObjectURL(blob);
					        link.setAttribute('download', fileName2);
					        document.body.appendChild(link);
					       if ("download" in document.createElement("a")) {
					       link.click();
						   document.body.removeChild(link);
					       } else {
							   document.body.removeChild(link);
					        // IE10+下载
					        navigator.msSaveBlob(blob, fileName2);
					       }
					   }

				});
			}
		},
	};
</script>

<style scoped lang="less">

</style>
